import _template from 'lodash/template';

const templateConfig = { interpolate: /{{([\s\S]+?)}}/g };

/**
 * @param template {String}
 */
export const templateString = template => _template(template, templateConfig);
